//#region Libraries
import styled from "styled-components";
//#endregion

const size = "35px";
export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    @media (max-width: 870px) {
        align-self: flex-start;
    }
`;
export const StepNumber = styled.div`
    display: grid;
    place-items: center;
    width: ${size};
    height: ${size};
    border-radius: 100%;
    color: var(--color);
    border: 3px solid var(--color);
    --color: var(--light-gray-4);
    font-weight: bold;
    position: relative;
    &.filling {
        --color: var(--purple-2);
    }
    & span {
        padding: 0 10px;
    }
`;
export const Description = styled.span`
    color: var(--light-gray-4);
    font-weight: 600;
    &.filling {
        color: var(--purple-2);
    }
`;
export const Line = styled.hr`
    background-color: var(--light-gray-1);
    width: 0;
    border: 0;
    height: 1.5px;
    margin: 0;
    &.filling {
        background-color: var(--purple-2);
    }
    @media (min-width: 870px) {
        width: 8%;
    }
    @media (max-width: 870px) {
        height: 20px;
        width: 1.5px;
        margin-left: 18px;
        align-self: flex-start;
    }
`;